/* ==========================================================================
   TEMPT — product page behaviour
   Vanilla JS, no dependencies, no globals. Every module no-ops if its markup
   isn't present, so it's safe on any template.
   ========================================================================== */

(function () {
  "use strict";

  /* Bind-once guard: the theme editor fires shopify:section:load and we
     re-boot, so every listener must attach at most once per element. */
  function bindOnce(el, key) {
    var attr = "data-tempt-bound-" + key;
    if (el.hasAttribute(attr)) return false;
    el.setAttribute(attr, "");
    return true;
  }

  /* Format cents using the shop's money format where we can, else plain USD. */
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (format && format.indexOf("amount_no_decimals") !== -1) {
      amount = String(Math.round(cents / 100));
    }
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "$" + parts.join(".");
  }

  /* --- gallery ----------------------------------------------------------- */

  function initGallery(root) {
    var gallery = root.querySelector("[data-tempt-gallery]");
    if (!gallery) return;

    var main = gallery.querySelector("[data-tempt-gallery-main]");
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-tempt-thumb]"));
    if (!main || !thumbs.length) return;

    var index = 0;

    function show(next) {
      index = (next + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      main.src = t.getAttribute("data-full");
      main.alt = t.getAttribute("data-alt") || "";
      thumbs.forEach(function (el, i) {
        el.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    thumbs.forEach(function (t, i) {
      if (bindOnce(t, "thumb")) {
        t.addEventListener("click", function () { show(i); });
      }
    });

    var prev = gallery.querySelector("[data-tempt-prev]");
    var next = gallery.querySelector("[data-tempt-next]");
    if (prev && bindOnce(prev, "nav")) prev.addEventListener("click", function () { show(index - 1); });
    if (next && bindOnce(next, "nav")) next.addEventListener("click", function () { show(index + 1); });

    show(0);
  }

  /* --- bundle selector --------------------------------------------------- */

  function initBundles(root) {
    var wrap = root.querySelector("[data-tempt-form]");
    if (!wrap) return;

    var radios = [].slice.call(wrap.querySelectorAll("[data-tempt-variant]"));
    if (!radios.length) return;

    var format = wrap.getAttribute("data-money-format") || "";
    var q = function (sel) { return root.querySelector(sel); };

    var priceEl   = q("[data-tempt-price]");
    var compareEl = q("[data-tempt-compare]");
    var badgeEl   = q("[data-tempt-save]");
    var atcPrice  = q("[data-tempt-atc-price]");
    var atcComp   = q("[data-tempt-atc-compare]");
    var barPrice  = q("[data-tempt-bar-price]");
    var barTitle  = q("[data-tempt-bar-title]");
    var atcBtn    = q("[data-tempt-atc]");
    var giftCards = [].slice.call(root.querySelectorAll("[data-tempt-gift]"));

    function sync() {
      var on = radios.filter(function (r) { return r.checked; })[0];
      if (!on) return;

      var price   = parseInt(on.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(on.getAttribute("data-compare"), 10) || 0;
      var save    = on.getAttribute("data-save") || "";
      var gifts   = parseInt(on.getAttribute("data-gifts"), 10) || 0;
      var title   = on.getAttribute("data-title") || "";
      var showCompare = compare > price;

      if (priceEl) priceEl.textContent = money(price, format);
      if (compareEl) {
        compareEl.textContent = showCompare ? money(compare, format) : "";
        compareEl.hidden = !showCompare;
      }
      if (badgeEl) {
        badgeEl.textContent = save;
        badgeEl.hidden = !save;
      }
      if (atcPrice) atcPrice.textContent = money(price, format);
      if (atcComp) {
        atcComp.textContent = showCompare ? money(compare, format) : "";
        atcComp.hidden = !showCompare;
      }
      if (barPrice) barPrice.textContent = money(price, format);
      if (barTitle) barTitle.textContent = title;

      // A variant Shopify reports unavailable disables checkout but never
      // blocks switching between bundles.
      if (atcBtn) {
        var available = on.getAttribute("data-available") !== "false";
        atcBtn.disabled = !available;
      }

      // Fallback for browsers without :has() — the CSS uses it for the
      // selected-card state, this mirrors it as a plain class.
      radios.forEach(function (r) {
        var label = r.closest(".tempt-bundle");
        if (label) label.classList.toggle("is-selected", r.checked);
      });

      giftCards.forEach(function (card, i) {
        var locked = i + 1 > gifts;
        card.classList.toggle("is-locked", locked);
        var label = card.querySelector("[data-tempt-gift-label]");
        var was   = card.querySelector("[data-tempt-gift-was]");
        var lock  = card.querySelector("[data-tempt-gift-lock]");
        if (label) label.textContent = locked ? "Locked" : card.getAttribute("data-gift-name");
        if (was) was.hidden = locked;
        if (lock) lock.hidden = !locked;
      });
    }

    radios.forEach(function (r) {
      if (bindOnce(r, "variant")) r.addEventListener("change", sync);
    });
    sync();

    // Load-time diagnostic (no click needed; survives because nothing has
    // navigated yet). Shows which gift variant ids resolved and which bundle
    // will add which gifts.
    if (window.console && bindOnce(wrap, "giftlog")) {
      console.info("[tempt] gifts configured — Gift A:",
        wrap.getAttribute("data-gift-a") || "(none)",
        "| Gift B:", wrap.getAttribute("data-gift-b") || "(none)",
        "| per bundle:", radios.map(function (r) {
          return (r.getAttribute("data-title") || r.value) + " → " + (r.getAttribute("data-gift-ids") || "no gifts");
        }).join("  ·  "));
    }

    /* --- gift-with-purchase: add gift products with the bundle ------------
       The bundle radio carries data-gift-ids (variant ids, comma separated).
       When present we add everything in one /cart/add.js call so the gifts
       land in the same cart as the qualifying bundle, then continue to the
       normal destination. Pricing them at $0 is Shopify's job (Buy X Get Y
       automatic discount) — see the Gifts settings in the theme editor.
       If anything fails we fall back to the plain form submit (no gifts). */
    var form = wrap.querySelector("form");
    if (form && bindOnce(form, "gifts")) {
      form.addEventListener("submit", function (e) {
        var on = radios.filter(function (r) { return r.checked; })[0];
        var giftIds = on ? (on.getAttribute("data-gift-ids") || "") : "";

        // Split-across-two-products composition
        var baseId  = parseInt(wrap.getAttribute("data-base-id"), 10) || 0;
        var dupId   = parseInt(wrap.getAttribute("data-dup-id"), 10) || 0;
        var basePlan= parseInt(wrap.getAttribute("data-base-plan"), 10) || 0;
        var dupPlan = parseInt(wrap.getAttribute("data-dup-plan"), 10) || 0;
        var qtyA    = on ? (parseInt(on.getAttribute("data-qty-a"), 10) || 0) : 0;
        var qtyB    = on ? (parseInt(on.getAttribute("data-qty-b"), 10) || 0) : 0;
        var subsOn  = wrap.getAttribute("data-subs-on") === "1";

        /* One-time mode: Shopify rejects a stale/deleted selling_plan id, and
           the Seal app embed can still inject one into the form at runtime
           even after its plan is gone. Strip any that appear so the add is a
           clean one-time purchase. */
        if (!subsOn) {
          basePlan = 0; dupPlan = 0;
          var strays = form.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]');
          for (var si = 0; si < strays.length; si++) strays[si].remove();
          if (strays.length && window.console) {
            console.info("[tempt] one-time mode — removed " + strays.length + " stray selling_plan field(s) before adding to cart.");
          }
        }

        /* This flag lives on the PRODUCT in Shopify, not in the theme. If it is
           set and no plan exists, nothing can add the product to a cart. */
        if (wrap.getAttribute("data-requires-plan") === "1" && !subsOn && window.console) {
          console.error("[tempt] This product is set to 'subscription only' (requires_selling_plan) but has no selling plan, so Shopify will refuse every add to cart. Fix in Admin: open the product, remove the subscription-only requirement (in Seal: remove the product from the subscription rule / re-enable one-time purchase), then save.");
        }
        if (wrap.getAttribute("data-dup-requires-plan") === "1" && !subsOn && window.console) {
          console.error("[tempt] The DUPLICATE product is set to 'subscription only' (requires_selling_plan) with no plan — same fix needed on it.");
        }
        // Only split when we have both ids and the duplicate is actually used.
        var doSplit = baseId && dupId && qtyB > 0 && qtyA > 0;

        if (doSplit && window.console) {
          console.info("[tempt] split add — this product x" + qtyA + " (" + baseId + "), duplicate x" + qtyB + " (" + dupId + ")");
        }
        if (doSplit && dupId && !dupPlan && window.console) {
          console.warn("[tempt] the duplicate product has no matching selling plan — that line will be one-time and full price. Attach the same Seal plan to it.");
        }

        if (!giftIds && !doSplit) {
          // Diagnostic: shows in DevTools console why no gifts were added.
          if (window.console) {
            console.info("[tempt] no gifts for this bundle — data-gift-ids is empty.",
              "Gift A id:", wrap.getAttribute("data-gift-a") || "(none)",
              "Gift B id:", wrap.getAttribute("data-gift-b") || "(none)",
              "→ pick both gift products in Theme editor › Product › Gifts, and make sure they are published to the Online Store channel.");
          }
          return; // native submit, nothing to add
        }
        if (!window.fetch) return; // no fetch: let the browser submit natively

        e.preventDefault();

        var plan = subsOn ? form.querySelector('input[name="selling_plan"]') : null;
        var planId = plan && plan.value ? parseInt(plan.value, 10) : 0;
        var items = [];

        if (doSplit) {
          // Same physical product, two listings. Both lines carry a plan when
          // they have one, so the whole order renews together.
          var a = { id: baseId, quantity: qtyA };
          if (basePlan || planId) a.selling_plan = basePlan || planId;
          items.push(a);

          var b = { id: dupId, quantity: qtyB };
          if (dupPlan) b.selling_plan = dupPlan;
          items.push(b);
        } else {
          var main = { id: parseInt(on.value, 10), quantity: 1 };
          if (planId) main.selling_plan = planId;
          items.push(main);
        }

        (giftIds ? giftIds.split(",") : []).forEach(function (raw) {
          var id = parseInt(raw, 10);
          if (id) {
            items.push({
              id: id,
              quantity: 1,
              properties: { _gift_with: on.getAttribute("data-title") || "bundle" }
            });
          }
        });

        var rt = form.querySelector('input[name="return_to"]');
        var dest = rt && rt.value ? rt.value : "/cart";
        if (atcBtn) atcBtn.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (r.ok) return r.json();
            // Surface Shopify's reason (e.g. variant unavailable / not published)
            return r.json().then(function (body) {
              if (window.console) console.error("[tempt] /cart/add.js rejected the gifts:", body);
              throw body;
            });
          })
          .then(function () { window.location.href = dest; })
          .catch(function (err) {
            if (window.console) console.warn("[tempt] falling back to plain add-to-cart (no gifts).", err);
            if (atcBtn) atcBtn.disabled = false;
            form.submit(); // bypasses this listener; bundle still goes in
          });
      });
    }
  }

  /* --- gift confetti ----------------------------------------------------- */

  function initConfetti(root) {
    var cards = [].slice.call(root.querySelectorAll("[data-tempt-gift]"));
    if (!cards.length) return;

    var colors = ["#1c3a13", "#d3fa99", "#1c3a13", "#d3fa99"];

    function burst(card) {
      if (card.classList.contains("is-locked")) return;
      var old = card.querySelector(".tempt-confetti");
      if (old) old.remove();

      var wrap = document.createElement("span");
      wrap.className = "tempt-confetti";
      wrap.setAttribute("aria-hidden", "true");

      for (var i = 0; i < 14; i++) {
        var angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
        var dist = 28 + Math.random() * 34;
        var piece = document.createElement("span");
        piece.style.width = 4 + Math.round(Math.random() * 3) + "px";
        piece.style.height = 7 + Math.round(Math.random() * 4) + "px";
        piece.style.background = colors[i % 4];
        piece.style.animationDelay = Math.random() * 70 + "ms";
        piece.style.setProperty("--dx", Math.cos(angle) * dist + "px");
        piece.style.setProperty("--dy", Math.sin(angle) * dist - 10 + "px");
        piece.style.setProperty("--rot", Math.round(Math.random() * 540 - 270) + "deg");
        wrap.appendChild(piece);
      }

      card.appendChild(wrap);
      setTimeout(function () { wrap.remove(); }, 900);
    }

    cards.forEach(function (card) {
      if (!bindOnce(card, "gift")) return;
      card.addEventListener("click", function () { burst(card); });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); burst(card); }
      });
    });
  }

  /* --- accordions -------------------------------------------------------- */

  function initAccordions(root) {
    [].slice.call(root.querySelectorAll("[data-tempt-accordions]")).forEach(function (group) {
      var triggers = [].slice.call(group.querySelectorAll("[data-tempt-accordion]"));
      triggers.forEach(function (t) {
        if (!bindOnce(t, "acc")) return;
        t.addEventListener("click", function () {
          var open = t.getAttribute("aria-expanded") === "true";
          triggers.forEach(function (o) { o.setAttribute("aria-expanded", "false"); });
          t.setAttribute("aria-expanded", open ? "false" : "true");
        });
      });
    });
  }

  /* --- delivery date ----------------------------------------------------- */

  function initDelivery(root) {
    [].slice.call(root.querySelectorAll("[data-tempt-delivery]")).forEach(function (el) {
      var days = parseInt(el.getAttribute("data-days"), 10) || 10;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = d.toLocaleDateString("en-US", {
        weekday: "long", month: "long", day: "numeric"
      });
    });
  }

  /* --- sticky mobile bar ------------------------------------------------- */

  function initMobileBar(root) {
    var bar = root.querySelector("[data-tempt-mobilebar]");
    if (!bar) return;

    if (!bindOnce(bar, "bar")) return;

    var atc = document.querySelector("[data-tempt-atc]");

    function onScroll() {
      var show;
      if (atc) {
        // Appear once the buy box's Add to cart has scrolled off the top.
        show = atc.getBoundingClientRect().bottom < 0;
      } else {
        show = window.scrollY > 620;
      }
      bar.classList.toggle("is-visible", show);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var btn = bar.querySelector("[data-tempt-mobile-atc]");
    if (btn) {
      btn.addEventListener("click", function () {
        var form = document.querySelector("[data-tempt-form] form");
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* --- boot -------------------------------------------------------------- */

  function boot(scope) {
    var root = scope || document;
    initGallery(root);
    initBundles(root);
    initConfetti(root);
    initAccordions(root);
    initDelivery(root);
    initMobileBar(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page reload.
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target || document);
  });
})();
